<div class="sold-out-container">
  <div class="sold-out">
    ELADVA
  </div>

</div>
